import { singleton } from "tsyringe";

import type {
    CommonAccountsPath,
    ConnectCommonAccountsOptions,
} from "@/features/connect-common-accounts/models/interface";

@singleton()
export class WindowPopupConnecter {
    /**
     * @description
     * 통합 계정 연결 팝업 열기
     * @param {CommonAccountsPath} path 통합계정 경로
     * @param {ConnectCommonAccountsOptions} options 통합계정 가입에 필요할 수 있는 옵션
     * @returns {Window | null}
     */
    public connect = (
        path: CommonAccountsPath,
        options?: ConnectCommonAccountsOptions,
    ): Window | null => {
        const popupBaseUrl = this.setAccountsBaseUrl(
            path,
            options?.email,
            options?.accessToken,
            options?.action,
        );
        const params = this.setPopupParams();

        const openPopup = window.open(popupBaseUrl, "redService", params);

        return openPopup;
    };

    /**
     * @description
     * url 설정하기
     * @param {CommonAccountsPath} path 통합계정 경로
     * @param {string} email 이메일
     * @param {string} accessToken 액세스 토큰
     * @param {string} action 이메일 찾기와 비밀번호 찾기 내 구별점
     * @returns {string}
     */
    private setAccountsBaseUrl = (
        path: CommonAccountsPath,
        email?: string,
        accessToken?: string,
        action?: string,
    ): string => {
        const newBaseUrl = new URL(path, import.meta.env.VITE_COMMON_ACCOUNTS_URL);

        newBaseUrl.searchParams.set("service", import.meta.env.VITE_SERVICE_ID);

        if (email) {
            newBaseUrl.searchParams.set("email", email);
        }

        if (accessToken) {
            newBaseUrl.searchParams.set("accessToken", accessToken);
        }

        if (action) {
            newBaseUrl.searchParams.set("action", action);
        }

        return newBaseUrl.toString();
    };

    /**
     * @description
     * 팝업 파라미터 설정하기
     * @returns {string}
     */
    private setPopupParams = (): string => {
        let params = "";

        params += `width= ` + screen.width;
        params += `, height= ` + screen.height;
        params += `, top=0, left=0`;
        params += `, fullscreen=yes`;

        return params;
    };
}
